import React from 'react';
import { Input, Select, Checkbox, Button, Space } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

const FIELD_TYPES = [
    { label: 'Text', value: 'text' },
    { label: 'Dropdown', value: 'dropdown' },
    { label: 'Date', value: 'date' },
    { label: 'Number', value: 'number' },
];

const emptyField = () => ({
    key: '',
    label: '',
    type: 'text',
    options: [],
    required: false,
});

const MetadataSchemaEditor = ({ value = [], onChange }) => {
    const fields = value || [];

    const updateField = (index, patch) => {
        const updated = fields.map((f, i) => (i === index ? { ...f, ...patch } : f));
        onChange(updated);
    };

    const addField = () => {
        onChange([...fields, emptyField()]);
    };

    const removeField = (index) => {
        onChange(fields.filter((_, i) => i !== index));
    };

    return (
        <div>
            {fields.map((field, index) => (
                <div
                    key={index}
                    style={{
                        display: 'flex',
                        gap: 8,
                        alignItems: 'flex-start',
                        marginBottom: 10,
                        padding: '10px 12px',
                        background: 'var(--tertiary-color)',
                        borderRadius: 6,
                        border: '1px solid rgba(255,255,255,0.07)',
                    }}
                >
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
                        <div style={{ display: 'flex', gap: 8 }}>
                            <Input
                                placeholder="Key (e.g. region)"
                                value={field.key}
                                onChange={(e) => updateField(index, { key: e.target.value })}
                                style={{ width: '40%' }}
                                size="small"
                            />
                            <Input
                                placeholder="Label (e.g. Region)"
                                value={field.label}
                                onChange={(e) => updateField(index, { label: e.target.value })}
                                style={{ width: '40%' }}
                                size="small"
                            />
                            <Select
                                value={field.type}
                                onChange={(val) => updateField(index, { type: val, options: val === 'dropdown' ? field.options : [] })}
                                options={FIELD_TYPES}
                                style={{ width: '20%' }}
                                size="small"
                            />
                        </div>
                        {field.type === 'dropdown' && (
                            <Select
                                mode="tags"
                                placeholder="Type options and press Enter"
                                value={field.options}
                                onChange={(vals) => updateField(index, { options: vals })}
                                style={{ width: '100%' }}
                                size="small"
                            />
                        )}
                        <Checkbox
                            checked={field.required}
                            onChange={(e) => updateField(index, { required: e.target.checked })}
                        >
                            <span style={{ fontSize: 12 }}>Required</span>
                        </Checkbox>
                    </div>
                    <Button
                        type="text"
                        danger
                        size="small"
                        icon={<DeleteOutlined />}
                        onClick={() => removeField(index)}
                    />
                </div>
            ))}
            <Button
                type="dashed"
                icon={<PlusOutlined />}
                onClick={addField}
                block
                size="small"
                style={{ marginTop: 4 }}
            >
                Add Field
            </Button>
        </div>
    );
};

export default MetadataSchemaEditor;
